import i18next from "i18next";
import { translations as validationTranslations } from "./validation/translations";
export var NSV = "raqbvalidation";
export var NSVP = "".concat(NSV, ":");
var i18n = i18next.createInstance();
i18n.init({
  fallbackLng: "en"
});
i18n.addResources("en", NSV, validationTranslations);
export var translateValidation = function translateValidation(key, args) {
  if (key !== null && key !== void 0 && key.str) {
    // already translated
    return key.str;
  }
  if (key !== null && key !== void 0 && key.key) {
    return translateValidation(key.key, key.args);
  }
  if (args === null) {
    return key;
  }
  return i18n.t(key.includes(":") ? key : NSVP + key, args);
};
export default i18n;